import axios from "@/plugins/axios";

export default {
  async getAllEvents(emis, status) {
    const events = await axios.postData("/get-all-events", {
      emis,
      status,
    });
    return events;
  },
  async getAllAgencyFees(url, token) {
    const fees = await axios.getData(url, token);
    return fees;
  },
  async getAllAppointmentsCurrentMonth(emis, status) {
    const appointments = await axios.postDataWithToken(
      "/auth/get-all-appointments-current-month",
      { emis, status },
      localStorage.getItem("token")
    );
    return appointments;
  },

  async getAllAppointmentsByClient(emis, status, clientID) {
    const appointments = await axios.postDataWithToken(
      "/auth/get-all-appointments-by-client",
      { emis, status, clientID },
      localStorage.getItem("token")
    );
    return appointments;
  },

  async getAllAppointmentsByStaff(emis, status, staffID) {
    const appointments = await axios.postDataWithToken(
      "/auth/get-all-appointments-by-staff",
      { emis, status, staffID },
      localStorage.getItem("token")
    );
    return appointments;
  },

  async getAllAppointmentsByStaffCurrentMonth(emis, status, staffID) {
    const appointments = await axios.postDataWithToken(
      "/auth/get-all-appointments-by-staff-current-month",
      { emis, status, staffID },
      localStorage.getItem("token")
    );
    return appointments;
  },
  async saveEvent(
    url,
    payload,
    selectedAgencyFee,
    selectedPayrollID,
    selectedInvoiceID,
    token
  ) {
    const events = await axios.postDataWithToken(
      url,
      {
        eventId: payload.id,
        title: payload.title,
        description: payload.description,
        startDate: payload.start,
        endDate: payload.end,
        privacy: payload.private,
        rateID: payload.rateID,
        hours: payload.hours,
        agencyFee: selectedAgencyFee.percentage,
        agencyFeeName: selectedAgencyFee.name,
        clientID: payload.clientID,
        staffIDs: payload.staffIDs,
        selectedPayrollID: selectedPayrollID,
        selectedInvoiceID: selectedInvoiceID,
      },
      token
    );
    return events;
  },
};
